import React, { useState, useEffect, useRef } from 'react';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function AddAbsence() {
  const [staffMembers, setStaffMembers] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [reason, setReason] = useState('');
  const [reasonText, setReasonText] = useState('');
  const [date, setDate] = useState(new Date());
  const [notes, setNotes] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchStaff = async () => {
      const staffSnapshot = await getDocs(collection(db, 'staff'));
      const staffList = staffSnapshot.docs.map(doc => ({ id: doc.id, name: doc.data().name }));
      setStaffMembers(staffList);
    };
    fetchStaff();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'staffabsences'), {
        name: selectedStaff,
        reason: reason,
        reasonText: reasonText,
        date: date,
        notes: notes
      });
      alert('Absence added successfully!');
      // Reset form
      setSelectedStaff('');
      setSearchTerm('');
      setReason('');
      setReasonText('');
      setDate(new Date());
      setNotes('');
    } catch (error) {
      console.error('Error adding absence: ', error);
      alert('Error adding absence. Please try again.');
    }
  };

  const handleStaffSelect = (staffName) => {
    setSelectedStaff(staffName);
    setSearchTerm(staffName);
    setShowDropdown(false);
  };

  const handleReasonChange = (selectedReason) => {
    setReason(selectedReason);
    if (selectedReason === 'Unexcused') {
      setReasonText('Unexcused');
    } else if (selectedReason !== 'Excused') {
      setReasonText('');
    }
  };

  const filteredStaff = staffMembers.filter(staff =>
    staff.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6 p-8">Add New Absence</h1>
        <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 p-10">
          <div className="mb-4 relative" ref={dropdownRef}>
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="staff">
              Staff Member
            </label>
            <input
              type="text"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Search for a staff member"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setShowDropdown(true);
              }}
              onFocus={() => setShowDropdown(true)}
              required
            />
            {showDropdown && (
              <ul className="absolute z-10 w-full bg-white border border-gray-300 mt-1 rounded-md shadow-lg max-h-60 overflow-auto">
                {filteredStaff.map((staff) => (
                  <li
                    key={staff.id}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => handleStaffSelect(staff.name)}
                  >
                    {staff.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Reason
            </label>
            <div className="flex space-x-4">
              {['Excused', 'Unexcused', 'Vacation', 'COVID'].map((option) => (
                <label key={option} className="inline-flex items-center">
                  <input
                    type="radio"
                    className="form-radio"
                    name="reason"
                    value={option}
                    checked={reason === option}
                    onChange={(e) => handleReasonChange(e.target.value)}
                    required
                  />
                  <span className="ml-2">{option}</span>
                </label>
              ))}
            </div>
          </div>
          {(reason === 'Excused' || reason === 'Unexcused') && (
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="reasonText">
                Reason Text
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="reasonText"
                type="text"
                placeholder="Enter reason"
                value={reasonText}
                onChange={(e) => setReasonText(e.target.value)}
                required
              />
            </div>
          )}
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="date">
              Date Absent
            </label>
            <DatePicker
              selected={date}
              onChange={(date) => setDate(date)}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="notes">
              Notes
            </label>
            <textarea
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="notes"
              placeholder="Enter any additional notes"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            ></textarea>
          </div>
          <div className="flex items-center justify-between">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="submit"
            >
              Add Absence
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddAbsence;